/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Subscription_Status_Up_To_DateInputs */

const en_plan_subscription_status_up_to_date = /** @type {(inputs: Plan_Subscription_Status_Up_To_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription status is up to date.`)
};

const es_plan_subscription_status_up_to_date = /** @type {(inputs: Plan_Subscription_Status_Up_To_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El estado de tu suscripción está actualizado.`)
};

/**
* | output |
* | --- |
* | "Your subscription status is up to date." |
*
* @param {Plan_Subscription_Status_Up_To_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_subscription_status_up_to_date = /** @type {((inputs?: Plan_Subscription_Status_Up_To_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Subscription_Status_Up_To_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_subscription_status_up_to_date(inputs)
	return en_plan_subscription_status_up_to_date(inputs)
});